// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"b340e894","246":"5de62c24","287":"982368ea","326":"a6081676","394":"856600e4","435":"80941233","552":"2f327c2d","571":"ad0fa4e3","603":"72c2abd5","646":"5c0a31bb","671":"6047b122","880":"8c8314e8","888":"b64b0d59","965":"13816e2e"}[chunkId] + ".chunk.js";
};